import { AxiosResponse } from "axios";
import ApiConstants from "../../../../../core/constants/api_constants.tsx";
import { request } from "../../../../../core/network/axiosInstance.tsx";

export class AuthenticationApiService {
    private readonly authBaseUrl: string;

    constructor() {
        this.authBaseUrl = ApiConstants().authentication;
    }

    /* REFRESH TOKEN */
    async refreshToken(refreshToken: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.authBaseUrl}refresh`,
            headers: {
                'authorization': 'Bearer ' + refreshToken
            },
            requiresToken: false,
        });
        return response;
    }

    /* LOGIN */
    async login(json: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.authBaseUrl}login`,
            data: json,
            headers: {
                'Content-Type': 'application/json',
            },
            requiresToken: false,
        });
        return response
    }

    /* REGISTER */
    async register(json: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.authBaseUrl}signup`,
            data: json,
            headers: {
                'Content-Type': 'application/json',
            },
            requiresToken: false,
        });
        return response
    }

    async registerInvitee(json: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.authBaseUrl}signup-invited`,
            data: json,
            headers: {
                'Content-Type': 'application/json',
            },
            requiresToken: false,
        });
        return response
    }

    async checkEmailAvailable(email: string, code: string): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.authBaseUrl}check-email/${email}/${code}`,
            requiresToken: false,
        });
        return response
    }

    async sendResetPasswordEmail(json: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.authBaseUrl}forgot-password`,
            data: json,
            headers: {
                'Content-Type': 'application/json',
            },
            requiresToken: false,
        });
        return response
    }

    async resetPassword(json: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.authBaseUrl}reset-password`,
            data: json,
            headers: {
                'Content-Type': 'application/json',
            },
            requiresToken: false,
        });
        return response
    }
} 